import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["controlled", "form", "indicator"]

  connect() {
    if (!this.hasFormTarget) {
      return
    }

    this.formTarget.addEventListener("turbo:submit-start", this.showLoading)
    this.formTarget.addEventListener("turbo:submit-end", this.hideLoading)
  }

  disconnect() {
    if (!this.hasFormTarget) {
      return
    }

    this.formTarget.removeEventListener("turbo:submit-start", this.showLoading)
    this.formTarget.removeEventListener("turbo:submit-end", this.hideLoading)
  }

  showLoading = () => {
    if (!this.hasIndicatorTarget) {
      return
    }

    this.indicatorTarget.classList.remove("hidden")

    this.controlledTargets.forEach((t) => {
      t.classList.add("loading")
    })
  }

  hideLoading = () => {
    if (!this.hasIndicatorTarget) {
      return
    }

    this.indicatorTarget.classList.add("hidden")

    this.controlledTargets.forEach((t) => {
      t.classList.remove("loading")
    })
  }
}
